module.exports = __WEBPACK_EXTERNAL_MODULE_Jmof__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"react","commonjs2":"react","amd":"react","root":"React","var":"React"}
// module id = Jmof
// module chunks = 0 1